import { useNavigation } from "@react-navigation/native";
import { StackNavigationProp } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigation/types";
import { useAuth0 } from "./useAuth0";

export function useLanding() {
  const navigation = useNavigation<StackNavigationProp<RootStackParamList>>();
  const { loginWithAuth0 } = useAuth0();

  const onLoginPressed = () => {
    navigation.navigate("Login");
  };

  const onGooglePressed = async () => {
    await loginWithAuth0(); // ahora esperamos al userInfo directamente
  };

  const onSignUpPressed = () => {
    console.log("Crear Cuenta Pressed");
  };

  return { onLoginPressed, onGooglePressed, onSignUpPressed };
}